import React, { useContext, useMemo, useState } from 'react';
import EDButton from '../../../../BaseComponents/Buttons/Button/EDButton';
// kommer anvdas framåt
/* import {
  EDAutoCompleteEdit,
  ISuggestion,
} from '../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit'; */
import { EDCard } from '../../../../BaseComponents/Card/EDCard';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import EDBox from '../../../../BaseComponents/EDBox/EDBox';
import { EDTextEdit } from '../../../../BaseComponents/TextEdit/EDTextEdit';
import {
  MeQuery,
  MeQueryVariables,
} from '../../Bokning/Rutiner/Kalender/Queries/MeQuery/_QueryTypes/MeQuery';
import meQuery from '../../Bokning/Rutiner/Kalender/Queries/MeQuery/MeQuery.gql';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { LoginStateContext } from '../../../Login/Contexts/LoginStateContext/LoginStateContext';
import {
  BisattningstyperQuery,
  BisattningstyperQueryVariables,
} from '../Queries/_QueryTypes/BisattningstyperQuery';
import bisattningstyperQuery from '../Queries/BisattningstyperQuery.gql';
import { RutinSettingsContext } from '../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import {
  BisattningsSettingsQuery,
  BisattningsSettingsQueryVariables,
} from '../Queries/_QueryTypes/BisattningsSettingsQuery';
import bisattningsSettingsQuery from '../Queries/BisattningsSettingsQuery.gql';
import { IStandardRutinWrapperProps } from '../../_StandardRutin/StandardRutin';
import EDDialog from '../../../../BaseComponents/Dialog/EDDialog';
import {
  BisattningsLokal,
  BisattningsLokalVariables,
} from '../Queries/_QueryTypes/BisattningsLokal';
import bisattningsLokal from '../Queries/BisattningsLokal.gql';
import EDStandardSelect from '../../../../BaseComponents/Selects/StandardSelect/EDStandardSelect';
import {
  BJ_LOKAL_ID,
  BJ_LOKAL_INDEX,
} from '../../../../Utils/LocalStorage/localStorageKeys';
import LamnaIn from './LamnaInHamtaUt/LamnaIn';
import HamtaUt from './LamnaInHamtaUt/HamtaUt';
import NyPlacering from './LamnaInHamtaUt/NyPlacering';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import EDGrid from '../../../../BaseComponents/GridComponents/EDGrid';
import { IconType } from '../../../../BaseComponents/Icon/Utils/IconDefinitions';
import EDDivider from '../../../../BaseComponents/Divider/EDDivider';
import { useIsSmallScreen } from '../../../../Hooks/useFullscreenView';
import EDSquareButton from '../../../../BaseComponents/Buttons/SquareButton/EDSquareButton';

interface IButtonSection {
  title: string;
  buttonText: string[];
  id: string[];
  lokalInfo: { index: number | undefined; id: string; status: string };
  onButtonClick: (text: string, id: string) => void;
}

interface IHoverableButton {
  text: string;
  id: string;
  lokalInfo: { index: number | undefined; id: string; status: string };
  onButtonClick: (text: string, id: string) => void;
}

const getIconType = (text: string): IconType => {
  const iconMap: { [key: string]: IconType } = {
    Avliden: 'avliden',
    'Ny placering': 'ny_placering',
    Stoft: 'stoft',
    xStoft: 'x_stoft',
    'Urna / Aska': 'urna_aska',
    Kista: 'kista',
    'Tom Urna': 'tom_urna',
  };

  return iconMap[text] || 'x_stoft';
};

const HoverableButton: React.FC<IHoverableButton> = React.memo(
  ({ text, id, lokalInfo, onButtonClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <EDSquareButton
        testId={`Knapp_${text}`}
        onClick={() => onButtonClick(text, id)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={lokalInfo.index === -1 || lokalInfo.id === ''}
        disabledReason="Lokal måste anges"
        // Lägga till nedan färg i temat?
        hoverBackgroundColor="#CFE9E7"
        icon={
          <EDIcon
            iconType={getIconType(text)}
            color={isHovered ? 'primary' : 'inherit'}
            size="special"
          />
        }
      >
        <EDTypography
          color={isHovered ? 'primary' : 'white'}
          fontSize={'12px'}
          whiteSpace={'nowrap'}
        >
          {text}
        </EDTypography>
      </EDSquareButton>
    );
  }
);

const ButtonSection: React.FC<IButtonSection> = ({
  title,
  buttonText,
  id,
  lokalInfo,
  onButtonClick,
}) => {
  return (
    <EDBox width={'100%'}>
      <EDTypography variant="h6" textAlign={'center'} mb={2}>
        {title}
      </EDTypography>
      <EDGrid
        container
        justifyContent="center"
        margin={0}
        maxWidth={'500px'}
        mb={6}
        mx={'auto'}
      >
        {buttonText.map((text, index) => (
          <EDGrid
            key={index}
            item
            container
            justifyContent={'center'}
            marginTop={0}
            marginBottom={2}
            xs={6}
            sm={6}
            md={4}
          >
            <HoverableButton
              text={text}
              id={id[index]}
              lokalInfo={lokalInfo}
              onButtonClick={onButtonClick}
            />
          </EDGrid>
        ))}
      </EDGrid>
    </EDBox>
  );
};

const LamnaInHamtaUt: React.FC<
  React.PropsWithChildren<IStandardRutinWrapperProps>
> = () => {
  const isSmallScreen = useIsSmallScreen();
  const [showReg, setShowReg] = useState(false);
  const [activeReg, setActiveReg] = useState('');
  const [activeRegID, setActiveRegID] = useState('');
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const routineAvailabilityContext = useContext(RutinSettingsContext);
  const routineID = routineAvailabilityContext.activeRoutine?.routine.rutinID;
  const loginStateContext = useContext(LoginStateContext);
  const [valjLokalOpen, setValjLokalOpen] = useState(false);
  const [lokalInfo, setLokalInfo] = useState<{
    index: number | undefined;
    id: string;
    status: string;
  }>({
    index: localStorage.getItem(BJ_LOKAL_INDEX)
      ? Number(localStorage.getItem(BJ_LOKAL_INDEX))
      : undefined,
    id: localStorage.getItem(BJ_LOKAL_ID) ?? '',
    status: 'No value',
  });
  const [previousLokalInfo, setPreviousLokalInfo] = useState(lokalInfo);

  const handleLokalChange = (lokal: number) => {
    if (lokalInfo.status === 'No value' || lokalInfo.status === 'Saved value') {
      setPreviousLokalInfo(lokalInfo);
    }
    setLokalInfo({
      index: lokal,
      id: lokalerRumPlacering?.db?.BOBisattningslokal_All?.[lokal]?.id ?? '',
      status: 'Changed value',
    });
  };

  const activeDatabaseOptions = useMemo(
    () => ({
      variables: {
        dbname: activeDatabase ?? 'noDBYet',
      },
      skip: !activeDatabase,
    }),
    [activeDatabase]
  );
  const { data: me_data } = useQuery<MeQuery, MeQueryVariables>(
    meQuery,
    activeDatabaseOptions
  );

  // kommer användas framåt?
  /*   const suggestions: ISuggestion[] = useMemo(() => {
    if (me_data?.me?.[0]?.userKontakter) {
      return me_data.me[0].userKontakter.map(kontakt => ({
        name: kontakt,
        value: kontakt,
      }));
    }
    return [];
  }, [me_data]); */

  const { data: bisattningstyp_data } = useQuery<
    BisattningstyperQuery,
    BisattningstyperQueryVariables
  >(bisattningstyperQuery, {
    variables: {
      dbname: activeDatabase ?? '',
      routineID: routineID,
    },
    fetchPolicy: 'network-only',
  });

  const aktivBisattningstyper = useMemo(() => {
    const items =
      bisattningstyp_data?.db?.BOBisattningstyp_All?.filter(
        item => item.AKTIV
      )?.map(item => ({
        id: item.id,
        BENAMNING: item.BENAMNING,
      })) ?? [];

    return items.length >= 3
      ? [...items.slice(0, 2), ...items.slice(3), items[2]]
      : items;
  }, [bisattningstyp_data]);

  const { data: bisattningSettings } = useQuery<
    BisattningsSettingsQuery,
    BisattningsSettingsQueryVariables
  >(bisattningsSettingsQuery, {
    variables: {
      dbname: activeDatabase ?? '',
    },
  });

  const { data: lokalerRumPlacering } = useQuery<
    BisattningsLokal,
    BisattningsLokalVariables
  >(bisattningsLokal, {
    variables: { dbname: activeDatabase ?? 'noDBYet' },
  });
  const lokaler =
    lokalerRumPlacering?.db?.BOBisattningslokal_All?.map((lokal, index) => ({
      header: lokal.BENAMNING,
      value: index,
    })) || [];

  const selectedLokalName = useMemo(() => {
    if (lokalInfo.index === undefined || lokalInfo.index === -1) {
      return 'Ingen lokal vald';
    }
    return (
      lokalerRumPlacering?.db?.BOBisattningslokal_All?.[lokalInfo.index]
        ?.BENAMNING ?? 'Okänd lokal'
    );
  }, [lokalInfo.index, lokalerRumPlacering]);

  return (
    <>
      {!showReg && (
        <EDBox
          display={'flex'}
          justifyContent={'center'}
          width={'100%'}
          height={'100%'}
        >
          <EDCard
            marginX={0}
            marginY={0}
            width={'100%'}
            maxWidth={'1000px'}
            minHeight={'100%'}
            padding={2}
            overflow="auto"
          >
            {/* Kontakt/Lokal */}
            <EDBox display={'flex'} marginBottom={3} flexDirection={'column'}>
              <EDTypography variant="h4">Lämna in/Hämta ut</EDTypography>
              <EDBox display={'flex'} flexDirection={'row'}>
                <EDTypography variant="h5">{selectedLokalName}</EDTypography>
                <EDButton
                  marginTop={0}
                  flat
                  onClick={() => setValjLokalOpen(true)}
                  testId="btnValjLokal"
                >
                  Välj lokal
                </EDButton>
              </EDBox>

              <EDBox width={'100%'} maxWidth={'350px'}>
                {/* kommer användas framöver */}
                {/*      <EDAutoCompleteEdit<ISuggestion>
                  label="Kontaktperson"
                  options={suggestions}
                  getOptionLabel={option => option.name || ''}
                  paddingRight={0.5}
                  fullWidth
                /> */}
                <EDTextEdit
                  label="Kontaktperson"
                  paddingLeft={0}
                  value={
                    me_data?.me?.[0]?.userIsBegrByra
                      ? ''
                      : loginStateContext.name
                  }
                />
              </EDBox>
            </EDBox>
            {isSmallScreen && <EDDivider />}

            <EDBox paddingTop={2} flexDirection={'column'}>
              {/* Lämna in */}
              <ButtonSection
                title="LÄMNA IN"
                buttonText={aktivBisattningstyper.map(item => item.BENAMNING)}
                id={aktivBisattningstyper.map(item => item.id)}
                lokalInfo={lokalInfo}
                onButtonClick={(text, id) => {
                  setShowReg(true);
                  setActiveReg(text);
                  setActiveRegID(id);
                }}
              />

              {/* Hämta ut */}
              <ButtonSection
                title="HÄMTA UT"
                buttonText={['Avliden']}
                id={[aktivBisattningstyper[0]?.id]}
                lokalInfo={lokalInfo}
                onButtonClick={(text, id) => {
                  setShowReg(true);
                  setActiveReg(text);
                  setActiveRegID(id);
                }}
              />

              {/* Ny placering */}
              {!me_data?.me?.[0]?.userIsBegrByra && (
                <ButtonSection
                  title="NY PLACERING"
                  buttonText={['Ny placering']}
                  id={[aktivBisattningstyper[1]?.id]}
                  lokalInfo={lokalInfo}
                  onButtonClick={(text, id) => {
                    setShowReg(true);
                    setActiveReg(text);
                    setActiveRegID(id);
                  }}
                />
              )}
            </EDBox>
          </EDCard>
        </EDBox>
      )}

      {showReg &&
        (activeReg === 'Avliden' ? (
          <HamtaUt
            id="HamtaUt"
            bisattningSettings={bisattningSettings}
            bisattningsTypID={activeRegID}
            open={showReg}
            setOpen={(open: boolean) => {
              setShowReg(false);
            }}
            lokalInfo={lokalInfo}
          />
        ) : activeReg === 'Ny placering' ? (
          <NyPlacering
            id="NyPlacering"
            bisattningSettings={bisattningSettings}
            open={showReg}
            setOpen={(open: boolean) => {
              setShowReg(false);
            }}
            lokalInfo={lokalInfo}
          />
        ) : (
          <LamnaIn
            id="LamnaIn"
            bisattningSettings={bisattningSettings}
            aktivBisattningstyp={activeReg}
            bisattningsTypID={activeRegID}
            open={showReg}
            setOpen={(open: boolean) => {
              setShowReg(false);
            }}
            lokalInfo={lokalInfo}
          />
        ))}
      <EDDialog
        title="Välj lokal"
        open={valjLokalOpen}
        onClose={() => setValjLokalOpen(false)}
        onExited={() => {
          if (lokalInfo.status === 'Changed value') {
            setLokalInfo(previousLokalInfo);
          }
        }}
        fullWidth
        footerActions={[
          {
            label: 'Ok',
            onClick: () => {
              setValjLokalOpen(false);
              setLokalInfo(state => ({
                ...state,
                status: 'Saved value',
              }));
              localStorage.setItem(BJ_LOKAL_INDEX, String(lokalInfo.index));
              localStorage.setItem(BJ_LOKAL_ID, String(lokalInfo.id));
            },
          },
        ]}
      >
        <EDStandardSelect<number>
          label="Urnrummet"
          onChange={handleLokalChange}
          value={lokalInfo.index}
          items={lokaler}
          testId="cmbLokal"
        />
      </EDDialog>
    </>
  );
};

export default LamnaInHamtaUt;
